import { useAppDispatch } from "../../app/hooks";
import { useMessages2 } from "../../hooks/useLanguage";
import { closePopup } from "../../app/popup-slice";
import styles from './info-warning-dialog.module.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons"
import { ButtonBar } from "../buttons";

export const InfoWarningDialog = () => {
    const dispatch = useAppDispatch()
    const { messages } = useMessages2();

    const handleClose = () => {
        dispatch(closePopup())
    }

    return (
        <div className={styles.dialogContainer}>
        
            <div className={styles.topContent}>
                <div className={styles.hiddenDiv}></div>
                <div className={styles.title}>
                    <h2>{messages?.sofa_invalid_title}</h2>
                </div>
                
                <FontAwesomeIcon
                    icon={faXmark}
                    className={styles.closeButton}
                    onClick={handleClose}
                />
            </div>
                
            <div className={styles.infoContainer} >
                <div className={styles.textInfo}>
                    { messages?.sofa_invalid_description }
                </div>
                <div className={styles.directButton}>             
                    <ButtonBar>
                        <button onClick={handleClose} className={styles.button}>{messages?.page_close_button}</button>
                    </ButtonBar>
                </div>
            </div> 

        </div>
    )
}